import { baseURL } from "../constants/v2/endPoints";
import * as apiService from "./v2/apiService";

export const ALERT_BUDGET_STATUS_URL = `${baseURL}api/notification/alertBudget`;

export async function getAlertBudgetStatus() {
  const response = await apiService.apiCall(ALERT_BUDGET_STATUS_URL, "GET");
  if (response?.errorCode !== 0) {
    throw new Error(response?.message || "Failed to load the alert budget");
  }
  return Boolean(response?.result?.alertBudgetActive);
}
